import React, { useState, useEffect } from 'react';
import {CRow,CCard} from '@coreui/react';
import CircularProgress from "@material-ui/core/CircularProgress";
 import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import * as wjFilter from "@grapecity/wijmo.react.grid.filter";
 import '@grapecity/wijmo.styles/wijmo.css';
 import settings from '../../config/settings';
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from "react-router";
import { useSelector } from 'react-redux';
 import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
 import DialogContent from "@material-ui/core/DialogContent";
import { Stack } from '@mui/material';
import { IconButton } from '@material-ui/core';
import CloseIcon from "@mui/icons-material/Close";
 const loader = {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    background: "rgba(255,255,255,0.4)",
    zIndex: "100",
    display: "table",
    width: "100%",
    height: "100%"
  }
  const toast_options = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  const button_style={
    fontSize: "26px",
    color: "#999",
    background: "none",
    border: "1px solid #999",
    borderRadius: "50px",
    width: "30px",
    height: "30px",
    float: "right",
    lineHeight: 0, 
}
const title_text = {
  color: 'white', 
  position: "fixed", 
  top: "106px", 
  left: "52px", 
  zIndex: "1030", 
  fontWeight: "bold",
  cursor:'pointer',
  padding:"8px 30px",
  background: 'rgb(115, 115, 115)',
  fontSize: '12px',
  borderTop: '1px solid #a8a8a8',
"@media (max-width: 1200px)": {
  top: '135px'
}}
const IssueHistoryData=({ open, handleClose,issueHistoryData })=>
{
    const history = useHistory();
     const [Isloader, setIsloader] = useState(false);
    const [historyData, setHistoryData] = useState();
    const compId = useSelector(state => state.companyId)
const [rowAndColumn,setRowAndColumn]=useState(false)
const [rowColumnData,setRowColumnData]=useState([])
 
 let details = localStorage.getItem("details");

 useEffect(()=> {
  setHistoryData(issueHistoryData);
 },[issueHistoryData]);

 if (details) {
  try {
    details = JSON.parse(details);
   } catch (error) {
    console.error("Error parsing JSON from local storage:", error);
    details = null;
  }
} else {
  console.log("No details found in local storage.");
}
 
    // useEffect(() => {
    //   if(localStorage.getItem("access_token")){
    //   if(compId){
    //     getHistoryData()
    //   }
    //   else{
    //     setTimeout(() => {
    //       toast.warn("Please Select Company", { toast_options });
    //     }, 1000);
    //   }
    // }
    // }, [updateIssueHistory])
  //   const getHistoryData = () => {
  //     setIsloader(true)
 
  // let userId = localStorage.getItem('userId')
  //  const headers = {
  //   "Content-Type": "application/json",
  //   Authorization: "Bearer " + localStorage.getItem('access_token'),
  //  };
  // let requestBody = {
  //     company_id: compId,
  //     user_id: userId,
  //     fileId:details.doc_id 
  //    }
  //  axios({
  //   method: "POST",
  //   url: settings.serverUrl + "/getReportHistory",
  //   data: JSON.stringify(requestBody),
  //   headers,
  // }).then((response) => {
  //    if (response.data.err) {
  //      toast.error(response.data.err, toast_options);
  //   }else{
  //     if(response.data.result){
  //       setHistoryData(response.data.result)
  //     }
  //   }
  //   setIsloader(false)
  // }).catch(err => {
  //    if(err.message.includes("403")){
  //   localStorage.clear();
  //   history.push("/");
  //   }
  //   else{
  //   toast.error(err.message, toast_options);
  //   }
  // });

  // }
 
    const getIsuessRowAndColumn = (ctx) => {
     
      if (!ctx?.item?.error_message?.reportIsuueCells) {
        console.error("reportIsuueCells is undefined");
        return;
      }
    
      let newRows = {};
      let arr = [];
    
      ctx.item.error_message.reportIsuueCells.forEach((cell) => {
        for (let rowIdx = cell.topRow; rowIdx <= cell.bottomRow; rowIdx++) {
          let cols = newRows["row" + rowIdx] || [];
          for (let cIdx = cell.leftCol; cIdx <= cell.rightCol; cIdx++) {
            cols.push("col" + cIdx);
          }
          newRows["row" + rowIdx] = cols;
        }
      });
    
      let reportIsuueCellsCopy = {
        ...rowColumnData,
        ...newRows,
      };
    
      setRowAndColumn(true);
      setRowColumnData([reportIsuueCellsCopy]);
    };
    
 

    const rowcolumnclose=()=>{
    setRowAndColumn(false)
    setRowColumnData([])
    }
   return (
    <>
 <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
 <IconButton
    style={{ position: "absolute", top: "8px", right: "8px" }}
    onClick={handleClose}
  >
    <CloseIcon />
  </IconButton>
       <DialogContent>
        <DialogContentText>
        <Grid className="container-fluid" style={{marginTop:40}}>
        <Grid item xs={12}>
           {historyData && historyData.length>0 ?
           <FlexGrid
           headersVisibility="Column"
           isReadOnly={true}
           autoGenerateColumns={false}
            itemsSource={historyData}
           selectionMode={false}
         
           style={{
             height: "auto",
             maxHeight: 400,
            margin:'0 auto'
           }}
         >
           <FlexGridColumn
           binding="user_email"
           header="USER EMAIL"
           cssClass="cell-header"
           width="*"
           margin="auto"
           style={{backgroundColor:'grey'}}
           >
 


           </FlexGridColumn>

           <FlexGridColumn
           binding="error_message"
           header="ERROR MESSAGE"
           cssClass="cell-header"
           width="*"
           style={{backgroundColor:'grey'}}
           >
             <FlexGridCellTemplate cellType="Cell" template={ctx =>
        
                  <React.Fragment>
                       <div >   {ctx.item["error_message"].issue}</div>
                  </React.Fragment>} />
           </FlexGridColumn>
 
           <FlexGridColumn
  binding="insert_time"
  header="INSERT TIME"
  cssClass="cell-header"
  width="*"
  style={{ backgroundColor: "grey" }}
>
  <FlexGridCellTemplate cellType="Cell" template={ctx =>
    <React.Fragment>
      {new Date(ctx.item["insert_time"]).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      })}{" "}
      {new Date(ctx.item["insert_time"]).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      })}
    </React.Fragment>
  } />
</FlexGridColumn>

 <FlexGridColumn
                binding="error_status"
                header="ERROR STATUS"
                cssClass="cell-header"
                width="*"
                style={{ backgroundColor: 'grey' }}>
             
              </FlexGridColumn>
              <FlexGridColumn
       
           cssClass="cell-header"
            maxHeight="20px"
     
           multiLine={true}
           style={{backgroundColor:'grey'}}
           >
             <FlexGridCellTemplate cellType="Cell"  template={ctx =>
        
  <React.Fragment>
    
 {Object.keys(ctx.item["error_message"]["reportIsuueCells"]).length>0?
   <span style={{ cursor: "pointer" ,marginLeft:'50%'}}>
                        <img
                          src="../error-icon-org.png"
                          style={{ height: 16 }}
                          onClick={()=>getIsuessRowAndColumn(ctx)}
                        />                  
                      </span>:''}
    </React.Fragment>} 
            
                  />
           </FlexGridColumn>
           {rowAndColumn &&
            <Dialog open={rowAndColumn}
            onClose={rowcolumnclose}>
            <DialogTitle style={{fontWeight:'bold',fontSize:18}}>Rows And Columns
            <button
        style={button_style}
        onClick={rowcolumnclose}>&times;</button></DialogTitle>
           
            <DialogContent style={{ minWidth: 100 }}>
              <DialogContentText>
             

  <FlexGrid
                     headersVisibility="Column"
                      autoGenerateColumns={false}
                      isReadOnly={true}
                      itemsSource={rowColumnData}
                      style={{
                        height: "auto",
                        maxHeight: 400,
                        margin: 0,
                      }}

                      selectionMode="MultiRange"
                      showSelectedHeaders="All"
                                             
                    >
                      
                     {rowColumnData.length>0 && Object.keys(rowColumnData[0]).map(key =>
                      <FlexGridColumn
                      binding={key}
                      header={key}
                      cssClass="cell-header"
                      width="*"
                      minWidth={100}
                       style={{backgroundColor:'grey'}}
                      >
                       

                      </FlexGridColumn>
                      )}  

                      <wjFilter.FlexGridFilter></wjFilter.FlexGridFilter>
                    </FlexGrid>
             

              </DialogContentText>
            </DialogContent>
           
          </Dialog>
          }
           <wjFilter.FlexGridFilter></wjFilter.FlexGridFilter>
         </FlexGrid>
         :
         <p style={{ width: "100%",color: "#c00",textAlign: "center", fontSize: "1.6em" }}>{Isloader?"": "No Record Found!"}</p>
           }
            
            </Grid>
           
            {Isloader &&
            <div style={loader}>
              <CircularProgress style={{ margin: "28% auto", display: "block" }} />
            </div>}
            <div><ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            /></div>
        </Grid>
        </DialogContentText>
      </DialogContent>
    </Dialog>
     

    {/* <Grid className="container-fluid" style={{marginTop:40}}>
        <Grid item xs={12} style={{ marginTop: 250}}>
           {historyData && historyData.length>0 ?
           <FlexGrid
           headersVisibility="Column"
           isReadOnly={true}
           autoGenerateColumns={false}
            itemsSource={historyData}
           selectionMode={false}
         
           style={{
             height: "auto",
             maxHeight: 400,
            margin:'0 auto'
           }}
         >
           <FlexGridColumn
           binding="user_email"
           header="USER EMAIL"
           cssClass="cell-header"
           width="*"
           margin="auto"
           style={{backgroundColor:'grey'}}
           >
 


           </FlexGridColumn>
           <FlexGridColumn
           binding="error_message"
           header="ERROR MESSAGE"
           cssClass="cell-header"
           width="*"
           style={{backgroundColor:'grey'}}
           >
             <FlexGridCellTemplate cellType="Cell" template={ctx =>
        
                  <React.Fragment>
                       <div >   {ctx.item["error_message"].issue}</div>
                  </React.Fragment>} />
           </FlexGridColumn>
         
           <FlexGridColumn
                binding="insert_time"
                header="INSERT TIME"
                cssClass="cell-header"
                width="*"
                style={{ backgroundColor: 'grey' }}>
             
              </FlexGridColumn>
              <FlexGridColumn
       
           cssClass="cell-header"
            maxHeight="20px"
     
           multiLine={true}
           style={{backgroundColor:'grey'}}
           >
             <FlexGridCellTemplate cellType="Cell"  template={ctx =>
        
  <React.Fragment>
    
 {Object.keys(ctx.item["error_message"]["reportIsuueCells"]).length>0?
   <span style={{ cursor: "pointer" ,marginLeft:'50%'}}>
                        <img
                          src="../error-icon-org.png"
                          style={{ height: 16 }}
                          onClick={()=>getIsuessRowAndColumn(ctx)}
                        />                  
                      </span>:''}
    </React.Fragment>} 
            
                  />
           </FlexGridColumn>
           {rowAndColumn &&
            <Dialog open={rowAndColumn}
            onClose={rowcolumnclose}>
            <DialogTitle style={{fontWeight:'bold',fontSize:18}}>Rows And Columns
            <button
        style={button_style}
        onClick={rowcolumnclose}>&times;</button></DialogTitle>
           
            <DialogContent style={{ minWidth: 100 }}>
              <DialogContentText>
             

  <FlexGrid
                     headersVisibility="Column"
                      autoGenerateColumns={false}
                      isReadOnly={true}
                      itemsSource={rowColumnData}
                      style={{
                        height: "auto",
                        maxHeight: 400,
                        margin: 0,
                      }}

                      selectionMode="MultiRange"
                      showSelectedHeaders="All"
                                             
                    >
                      
                     {rowColumnData.length>0 && Object.keys(rowColumnData[0]).map(key =>
                      <FlexGridColumn
                      binding={key}
                      header={key}
                      cssClass="cell-header"
                      width="*"
                      minWidth={100}
                       style={{backgroundColor:'grey'}}
                      >
                       

                      </FlexGridColumn>
                      )}  

                      <wjFilter.FlexGridFilter></wjFilter.FlexGridFilter>
                    </FlexGrid>
             

              </DialogContentText>
            </DialogContent>
           
          </Dialog>
          }
           <wjFilter.FlexGridFilter></wjFilter.FlexGridFilter>
         </FlexGrid>
         :
         <p style={{ width: "100%",color: "#c00", marginTop:150, textAlign: "center", fontSize: "1.6em" }}>{Isloader?"": "No Record Found!"}</p>
           }
            
            </Grid>
           
            {Isloader &&
            <div style={loader}>
              <CircularProgress style={{ margin: "28% auto", display: "block" }} />
            </div>}
            <div><ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            /></div>
        </Grid> */}
        
  </>
  );
}
 
export default IssueHistoryData;







